import type { SortRule } from "@/shared/types";
import type { BasicInformationRow } from "./types";

/**
 * Pure transformations (convention section 24): input → function → output,
 * no Redux, no API calls. Calculation only.
 */

/** Named columns exported to CSV; `dynamic_*` columns are excluded. */
export const basicInformationExportColumns = [
  { header: "Email", field: "email" },
  { header: "Full Name", field: "fullName" },
  { header: "Status", field: "status" },
  { header: "Role", field: "role" },
  { header: "Department", field: "department" },
  { header: "Salary", field: "salary" },
  { header: "Quantity", field: "quantity" },
  { header: "Time Spent (s)", field: "timeSpent" },
  { header: "Created", field: "createdAt" },
] as const satisfies Array<{ header: string; field: keyof BasicInformationRow }>;

/** Client-side sort used for CSV export (the table sorts internally). */
export function sortBasicInformation(
  rows: BasicInformationRow[],
  sort: SortRule[],
): BasicInformationRow[] {
  if (sort.length === 0) {
    return rows;
  }
  return [...rows].sort((a, b) => {
    for (const rule of sort) {
      const left = a[rule.id];
      const right = b[rule.id];
      if (left === right) {
        continue;
      }
      const comparison =
        typeof left === "number" && typeof right === "number"
          ? left - right
          : String(left ?? "").localeCompare(String(right ?? ""));
      return rule.desc ? -comparison : comparison;
    }
    return 0;
  });
}
